import { ProductType } from "../types/product";

export const parseProductType = (type?: ProductType) => {
  switch (type) {
    case ProductType.shortCall:
      return "15 min. Video Call";
    case ProductType.longCall:
      return "30 min. Video Call";
    case ProductType.written:
      return "Written Feedback";
    case ProductType.audio:
      return "Audio Feedback";
    case ProductType.video:
      return "Video Feedback";
    default:
      return "";
  }
};
